import React, { useState, useEffect } from 'react';
import './subscriber.css';

const Subscriber = () => {
  const [emailId, setEmailId] = useState('');
  const [mailError, setMailError] = useState(false);
  const [mailErrorMessage, setMailErrorMessage] = useState('');
  const [showErrorAlert, setShowErrorAlert] = useState(false);

  useEffect(() => {
    let timeoutId;
    if (showErrorAlert) {
      // Automatically hide the alert after 4 seconds
      timeoutId = setTimeout(() => {
        setShowErrorAlert(false);
      }, 4000);
    }
    
    // Clean up the timeout if the component unmounts or showErrorAlert changes
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [showErrorAlert]);

  const inputMail = (e) => {
    if (mailError) setMailError(false);
    setEmailId(e.target.value);
  };

  const submit = () => {
    const frm = document.getElementsByName('previewForm')[0];

    if ((emailId !== '') && (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailId))) {
      frm.submit();
      setEmailId('');
    } else {
      setShowErrorAlert(true);
      setMailError(true);

      // custom email validation message
      if (emailId === '') {
        setMailErrorMessage('Email is required');
      } else {
        setMailErrorMessage('Please enter a valid mail id');
      }
    }
  };

  return (
    <div className="lender_subscriber_container">
      {/* Toast-style notification */}
      {showErrorAlert && (
        <div className="lender_subscriber_notification">
          <div className="lender_subscriber_notification_icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
              <path fill="none" d="M0 0h24v24H0z"/>
              <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5h2v2h-2v-2zm0-8h2v6h-2V7z" fill="currentColor"/>
            </svg>
          </div>
          <span className="lender_subscriber_notification_message">
            Please enter a valid mail id
          </span>
        </div>
      )}

      <form 
        id="previewForm" 
        name="previewForm" 
        encType="multipart/form.data" 
        target="_blank" 
        method="post" 
        action="https://secure.campaigner.com/csb/Public/ProcessHostedForm.aspx"
      >
        <input id="__VIEWSTATEENCRYPTED" type="hidden" name="__VIEWSTATEENCRYPTED" />
        <input id="FormInfo" value="2f1521b9-a386-4e84-8cf9-3d453cb8c351" type="hidden" name="FormInfo" />

        <div className="lender_subscriber_input_group">
          <input 
            type="email" 
            className="lender_subscriber_input" 
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" 
            placeholder="Enter a valid email" 
            name="1940782" 
            contactattributeid="1940782" 
            onChange={(e) => inputMail(e)} 
            value={emailId} 
            required 
          />
          
          {mailError && (
            <p className="lender_subscriber_error">
              {mailErrorMessage}
            </p>
          )}
          
          <button 
            className="lender_subscriber_button" 
            type="button" 
            onClick={submit} 
            title="Click here to submit the form"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default Subscriber;